import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";

import { getWorkInformationRes } from "core/http/service/personnelInformation/resTypes";

interface InitialState {
  status: ReduxStateType;
  data: getWorkInformationRes;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: {
    departmentNameL1: "",
    departmentNameL2: "",
    departmentNameL3: "",
    employeeCode: "",
    employeeType: "",
    fullName: "",
    joinDateMb: "",
    joinDateMbs: "",
    marketingId: "",
    positionGroupName: "",
    laborContractName: "",
    managementLevelName: "",
    positionName: "",
    titleName: "",
    workingAddressName: "",
  },
};

const getWorkInformationSlice = createSlice({
  name: "getWorkInformation",
  initialState,
  reducers: {
    getWorkInformationStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getWorkInformationSuccess: (
      state,
      action: PayloadAction<getWorkInformationRes>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getWorkInformationFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetWorkInformation: () => {
      return { ...initialState };
    },
  },
});

export const {
  getWorkInformationStart,
  getWorkInformationSuccess,
  getWorkInformationFailed,
  resetWorkInformation,
} = getWorkInformationSlice.actions;

export default getWorkInformationSlice.reducer;
